import { useEffect } from "react";
import { useFileStore } from "../../../../../store/useFileStore";

const DocStepSquarWizardSCSS = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store);

    useEffect(() => {
        let value = `.wizard_wrapper {
    .wizard_progress {
        height: 4px;
        top: 35px;
        background-color: rgb(52, 152, 219);
    }
    .step_block {
        .step_wrapper {
            .wizard_icon {
                width: 70px;
                height: 70px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 3px solid var(--border-color);
                background-color: var(--bg-content);
                i {
                    font-size: 22px;
                    color: var(--content-text-color);
                }
                &.active {
                    border: 3px solid rgb(52, 152, 219);
                    background-color: rgb(52, 152, 219);
                    i {
                        color: #fff !important;
                    }
                }
            }
        }
    }
    .step_title {
        display: block;
        margin-top: 5px;
        color: var(--content-text-color);
        font-size: 17px;
        &.step_title_active {
            color: rgb(52, 152, 219);
        }
    }
    .step_content {
        padding: 30px 20px 10px 20px;
        .step_content_title {
            color: var(--hedging-text-color);
        }
    }
    .step_btn_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        button {
            min-width: 140px;
            font-size: 14px;
            font-weight: 600;
            padding: 8px 12px;
            background-color: rgb(52, 152, 219);
            color: #fff;
            border: rgb(52, 152, 219);
            border-radius: 4px;
        }
    }
}
`;

        setStore({ docStepSquarWizardSCSS: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default DocStepSquarWizardSCSS;
